<template>
  <section
    class="login"
    @keyup.enter="passwordReset">
    <router-link
      :to="{ name: 'LoginPage' }"
      class="pointer"
      tag="span">
      <img
        class="login__logo show-hand"
        style="display: inline-block !important;"
        src="~@/assets/img/SB-Images/app-logo.svg"
        alt="AI Number" >
    </router-link>
    <h1>Reset password</h1>
    <div class="login-additionals">
      <span>Enter your new password for account <b>{{ email }}</b>.</span>
    </div>
    <ValidationObserver
      ref="customFieldObserver"
      v-slot="{ valid, pristine }" >
      <div class="login-form">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|min:8"
          name="Password" >
          <b-form-group
            label="Password"
            label-for="password">
            <b-form-input
              id="password"
              v-model="password"
              name="password"
              type="password"
              placeholder="New password (at least 8 characters)"
              class="sb2-bordered sb2-hoverable sb2-focusable"
              trim/>
            <!-- password validation -->
            <div
              v-if="errors[0]"
              class="error flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.ERROR"
                :color="SBColors.redPrimary"
                :size="12" />
              <span>{{ errors[0] }} Minimum 8 characters needed.</span>
            </div>
          </b-form-group>
        </ValidationProvider>

        <div
          v-if="errorMessage && errorMessage.length"
          class="main-error flex center-all">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errorMessage }}</span>
        </div>

        <b-button
          variant="primary"
          :disabled="sending || !valid || pristine"
          :class="{loading: sending}"
          class="flex center-all settings__actions--save"
          block
          @click="passwordReset">
          <span>Change Password</span>
          <Spinner
            v-if="sending"
            :size="16"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </div>
    </ValidationObserver>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { extend } from 'vee-validate';
import { min } from 'vee-validate/dist/rules';
import setValidationErrors from '@/helpers/validationErrors';
import FieldFocusBlur from '@/mixins/FieldFocusBlur';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import Spinner from '@/components/common/Spinner';

extend('min', min);

export default {
  name: 'ResetPassword',
  components: {
    SBIcon,
    Spinner,
  },
  mixins: [FieldFocusBlur],
  data() {
    return {
      email: '',
      password: '',
      resetCode: '',
      sending: false,
      disableEmail: false,
      errorMessage: '',
      validationErrors: {},
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      authenticated: 'user/authenticated',
      apiError: 'user/apiError',
    }),
  },
  watch: {
    authenticated(auth) {
      if (auth) {
        this.sending = false;
        if (this.inviteToken && this.inviteToken.length) {
          this.acceptMerchantInvitation({ invite_token: this.inviteToken });
        }
        this.$router.push({ name: 'logged-in-landing-page' });
      }
    },
    apiError(error) {
      this.sending = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  beforeMount() {
    this.finalizeSplashView();
  },
  mounted() {
    if (this.$route.query.reset_code) {
      this.resetCode = this.$route.query.reset_code;

      if (this.$route.query.email) {
        this.email = this.$route.query.email;
        this.disableEmail = true;
      }
    }
  },
  methods: {
    ...mapActions({
      resetPassword: 'user/resetPassword',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    passwordReset() {
      this.errorMessage = '';
      this.validationErrors = {};
      if (this.$refs.customFieldObserver.flags.valid) {
        this.sending = true;
        const payload = {
          email: this.email,
          new_password: this.password,
          reset_code: this.resetCode,
        };
        this.resetPassword(payload);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings__actions--save {
  margin-top: 30px;
  height: 44px;
}
</style>
